import { GET, POST, PUT, DELETE } from './connect';

export const CONFLUENCE_API_BASE_URL = '/rest/api';
export const CONFLUENCE_V2_API_BASE_URL = '/api/v2';

export const getContent = (id, data) => GET(`${CONFLUENCE_API_BASE_URL}/content/${id}`, data);

export const postContent = (data) => POST(`${CONFLUENCE_API_BASE_URL}/content`, data);

export const putContent = (id, data) => PUT(`${CONFLUENCE_API_BASE_URL}/content/${id}`, data);

export const deleteContent = (id) => DELETE(`${CONFLUENCE_API_BASE_URL}/content/${id}`);

export const getContentProperty = (id, key) =>
	GET(`${CONFLUENCE_API_BASE_URL}/content/${id}/property/${key}`, {});

export const getContentChildren = (id, type, data) =>
	GET(`${CONFLUENCE_API_BASE_URL}/content/${id}/child/${type}`, data);

export const putContentProperty = (id, key, data) =>
	PUT(`${CONFLUENCE_API_BASE_URL}/content/${id}/property/${key}`, data);

export const postContentProperty = (id, data) =>
	POST(`${CONFLUENCE_API_BASE_URL}/content/${id}/property`, data);

export const getLabels = (id) => GET(`${CONFLUENCE_API_BASE_URL}/content/${id}/label`, {});

export const searchContent = (data) => GET(`${CONFLUENCE_API_BASE_URL}/content/search`, data);

export const searchAll = (data) => GET(`${CONFLUENCE_API_BASE_URL}/search`, data);

export const searchUsers = (data) => GET(`${CONFLUENCE_API_BASE_URL}/search/user`, data);

export const getSpace = (key) => GET(`${CONFLUENCE_API_BASE_URL}/space/${key}`, {});

export const getSpaceByKeyV2 = (key) => GET(`${CONFLUENCE_V2_API_BASE_URL}/spaces?keys=${key}`, {});

export const getSpacePermissionsV2 = ({ id, targetType, operation, nextUrl }) => {
	const params = `&operation-target-type=${targetType}&operation-key=${operation}`;
	const defaultUrl = `${CONFLUENCE_V2_API_BASE_URL}/spaces/${id}/permissions?limit=250${params}`;
	const requestUrl = nextUrl ? nextUrl.replace('/wiki', '') + params : defaultUrl;
	return GET(requestUrl, {});
};
